export const siteInfo = {
  name: "吃瓜爆料",
  slogan: "最新娱乐八卦 · 社会新闻热点",
  description:
    "吃瓜爆料是一个聚合娱乐八卦与社会新闻热点的资讯门户，实时为你送上明星动态、社会热点事件与多角度深度解析，轻松浏览、快速了解。",
  email: "hello@chigua-demo.com",
  address: "浙江省杭州市西湖区文三路 199 号 创意大厦 12 层",
  friendLinks: [
    { name: "娱乐观察周刊", url: "/category/entertainment" },
    { name: "社会热点聚焦", url: "/category/society" },
    { name: "明星动态速递", url: "/category/star" },
    { name: "全网热点榜", url: "/category/hot" },
    { name: "关于我们", url: "/about" },
  ],
};